import Navbar from '../components/Navbar';
import {Contact} from '../components/Contact'; 
import Footer from '../components/Footer';


export const Meet = () => {
    return (
        <>
            <Navbar />
            <div className="meet-mobile-spacing">
                <Contact/>
            </div>
            <Footer />
        </>
    );
}